import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import AppointmentTypesList from './AppointmentTypesList';
import TopicsList from './TopicsList';
import { useGetFacilityServices } from './hooks/useGetFacilityServices';

const Customize = () => {
  const { data: services } = useGetFacilityServices();

  return (
    <div
      style={{ backgroundColor: '#fff', padding: '20px', minHeight: '100vh' }}
    >
      <Col md={12} lg={12} className="customize-container">
        <Card className="mx-3">
          <div className="customize-header">Customize Features</div>
          <CardBody className="border p-3">
            {!services?.isBoardingOnly && <AppointmentTypesList />}
            <TopicsList />
          </CardBody>
        </Card>
      </Col>
    </div>
  );
};

export default Customize;
